<template>
  <div id="relListCli">
    <section class="card mt-4">
      <b-card-header
        header="Clientes que não compram há algum tempo"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="cardBody">
        <section>
          <b-pagination-nav size="sm" :number-of-pages="pObjPaginacao.length" :pages="pObjPaginacao"  v-model="current_page" @input="buscarClientesPorPagina"  align="right" use-router></b-pagination-nav>
        </section>
        <b-card-text class="table">
          <b-table bordered striped :items="clientes" :fields="fieldsClientes">
            <template slot="mobile" slot-scope="row">
              <div class="form-row mb-1">
                <div class="col-md-8"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                <div class="col-md-4 txtRight"><strong>Cód.: {{row.item.codCliente}}</strong></div>
              </div>
              <div class="form-row mb-1">{{toCapitalize(row.item.razaoSocial)}}</div>
              <div class="form-row mb-1">
                <div class="col-md-8" v-if="row.item.cnpjCpf.length === 14">CNPJ: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
                <div class="col-md-8" v-else>CPF: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
                <div class="col-md-4 txtRight">{{row.item.telefone}}</div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8">Últ. Compra: {{row.item.emissao}}</div>
                <div class="col-md-4 txtRight">R$ {{formatterValue(row.item.valor)}}</div>
              </div>
            </template>
          </b-table>
        </b-card-text>
        <section class="mt-3">
          <b-pagination-nav size="sm" :number-of-pages="pObjPaginacao.length" :pages="pObjPaginacao"  v-model="current_page" @input="buscarClientesPorPagina"  align="right" use-router></b-pagination-nav>
        </section>
      </b-card>
    </section>
    <BlockUI v-if="blockUI.visibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import relatoriosService from '@/services/relatorios'
  import ToastVue from '../layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'
  export default {
    components: {
      ToastVue,
      spinnerVue
    },
    props: {
      pObjClientes: {},
      pObjPaginacao: {},
      pTipoRelatorio: {}
    },
    data () {
      return {
        cor: '',
        current_page: 1,
        blockUI: {
          message: '',
          blockUiVisibility: false
        },
        tipoPedido: [],
        statusSelecionado: {},
        clientes: [],
        fieldsClientes: [
          {
            key: 'codCliente',
            label: 'Cód. Cli.',
            sortable: true,
            class: 'relCliCod'
          },
          {
            key: 'fantasia',
            label: 'Fantasia',
            sortable: true,
            class: 'relCliFant txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'razaoSocial',
            label: 'Razão Social',
            sortable: true,
            class: 'relCliRaz txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'cnpjCpf',
            label: 'CNPJ/CPF',
            sortable: true,
            class: 'relCliCnpj',
            formatter: this.formatterCnpjCpf
          },
          {
            key: 'telefone',
            label: 'Telefone',
            sortable: true,
            class: 'relCliTel'
          },
          {
            key: 'emissao',
            label: 'Emissão',
            sortable: true,
            class: 'relCliVen txtCenter'
          },
          {
            key: 'valor',
            label: 'Total R$',
            sortable: true,
            class: 'relCliVal txtRight',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobile',
            class: 'relCliMobile txtLeft'
          }
        ]
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
    },
    watch: {
      pObjClientes: function (newVal, oldVal) { // watch it
        // console.log(JSON.stringify(newVal))
        this.clientes = newVal
      }
    },
    methods: {
      buscarClientesPorPagina: function () {
        let paginaCorrente = this.current_page - 1
        let paginacao = this.pObjPaginacao[paginaCorrente]
        this.blockUI.visibility = true
        this.blockUI.message = 'Listando clientes, aguarde...'
        // console.log(JSON.stringify(paginacao))
        let paramCliente = {tipoRelatorio: this.pTipoRelatorio, paginacao: paginacao.pagina, registrosPorPagina: paginacao.registrosPorPagina}
        relatoriosService.listarClientes(paramCliente).then(response => {
          this.clientes = response.data.clientes
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterCnpjCpf: function (value) {
        if (value.length === 14) {
          value = value.replace(/^(\d{2})(\d)/, '$1.$2')
          value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
          value = value.replace(/(\d{4})(\d)/, '$1-$2')
          return value
        }
        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
          return value
        }
      },
      showMessage: function (message, title, variantColor) {
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast')
      },
      relatorioCliente: function () {
        this.blockUI.blockUiVisibility = true
        this.blockUI.message = 'Listando clientes, aguarde...'
        relatoriosService.listarClientes().then(response => {
          this.clientes = response.data
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.blockUiVisibility = false
        })
      },
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: auto;
    max-height: 350px;
    font-size: 14px;
  }
  .imgTable {
    width: 50px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/items/relatorioClientesNaoCompramVue.vue